



















import {Vue, Component, Watch} from 'vue-property-decorator';
import QC from '@/components/query/query-constructor';

function syntaxHighlight(json: string) {
  if (typeof json != 'string') {
    json = JSON.stringify(json, undefined, 2);
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var cls = 'number';
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key';
      } else {
        cls = 'string';
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean';
    } else if (/null/.test(match)) {
      cls = 'null';
    }
    return '<span class="' + cls + '">' + match + '</span>';
  });
};

@Component
export default class Devbox extends Vue {
  active: boolean = false;
  query: any = '';

  mounted(){
    window.addEventListener('keyup', (ev)=>{
      if (ev.key === 'p' && ev.altKey)
        this.active = !this.active;
    })
  }

  @Watch('$route.params.data')
  query_updated(data: any){
    this.query = syntaxHighlight(JSON.stringify(QC.decode(data), null, 2))
  }

}
